export default __webpack_public_path__ + "static/media/39091.be846bba.jpg";